import { render, staticRenderFns } from "./AgentsCrud.vue?vue&type=template&id=108a5320&scoped=true&"
import script from "./AgentsCrud.vue?vue&type=script&lang=js&"
export * from "./AgentsCrud.vue?vue&type=script&lang=js&"
import style0 from "./AgentsCrud.vue?vue&type=style&index=0&id=108a5320&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a5320",
  null
  
)

export default component.exports